import { useCacheKey } from './useCacheKey';

export function useDecisions(flag: string): string;
export function useDecisions(flag?: undefined): Map<string, string>;
export function useDecisions(flag?: string | undefined) {
    const { cookies } = useCacheKey();
    const featureFlags = new Map<string, string>(
        Object.entries(JSON.parse(cookies.get('x-petm-decisions') ?? '{}'))
    );

    if (flag) return featureFlags.get(flag) as string;

    return featureFlags;
}
